import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  without: 'No sabés cuánto ganás',
  with: 'Conocés tus números'
}, {
  without: 'El dinero desaparece',
  with: 'Controlás cada peso'
}, {
  without: 'Vivís improvisando',
  with: 'Tenés un plan financiero'
}, {
  without: 'Tomás decisiones a ciegas',
  with: 'Decidís con información'
}, {
  without: 'Sentís incertidumbre',
  with: 'Ganás tranquilidad'
}, {
  without: 'Te cuesta crecer',
  with: 'Creás bases sólidas para crecer'
}];
export function ComparisonTable() {
  return <section className="py-14 md:py-20 bg-background" data-id="element-34">
      <div className="container mx-auto px-5 md:px-6" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-36">
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-5 text-balance" data-id="element-37">
            LA DIFERENCIA ENTRE SEGUIR SOLO O{' '}
            <span className="text-primary italic" data-id="element-38">TENER UN SISTEMA</span>
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto" data-id="element-39">
          <div className="bg-surface rounded-2xl md:rounded-3xl border border-surface-light overflow-hidden" data-id="element-40">
            <div className="grid grid-cols-2 border-b border-surface-light bg-surface-light/30" data-id="element-41">
              <div className="p-3 md:p-6 text-center" data-id="element-42">
                <h3 className="text-[11px] sm:text-sm md:text-xl font-serif text-text-muted leading-tight" data-id="element-43">
                  SIN REINICIA TUS FINANZAS
                </h3>
              </div>
              <div className="p-3 md:p-6 text-center bg-primary/5 border-l border-surface-light" data-id="element-44">
                <h3 className="text-[11px] sm:text-sm md:text-xl font-serif text-primary-light leading-tight" data-id="element-45">
                  CON REINICIA TUS FINANZAS
                </h3>
              </div>
            </div>

            <div className="divide-y divide-surface-light" data-id="element-46">
              {comparisons.map((row, i) => <motion.div key={i} initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08
            }} className="grid grid-cols-2" data-id="element-47">
                  <div className="p-3 md:p-5 flex items-center gap-2.5 md:gap-4" data-id="element-48">
                    <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-49">
                      <XIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-red-400" data-id="element-50" />
                    </div>
                    <span className="text-text-muted text-xs sm:text-sm md:text-base leading-tight" data-id="element-51">
                      {row.without}
                    </span>
                  </div>
                  <div className="p-3 md:p-5 flex items-center gap-2.5 md:gap-4 bg-primary/5 border-l border-surface-light" data-id="element-52">
                    <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-primary/20 flex items-center justify-center" data-id="element-53">
                      <CheckIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-primary" data-id="element-54" />
                    </div>
                    <span className="text-white font-medium text-xs sm:text-sm md:text-base leading-tight" data-id="element-55">
                      {row.with}
                    </span>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}